import { getFiltersFromGrid } from "../../../features/filterValues/lib/getFiltersFromGrid.js";
import { instanceOfGrid } from "../../../shared/lib/grid/instanceOfGrid.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
function getExcludingItems(filterItems, data, excludeCondition) {
  const filtersToRemove = filterItems.reduce((acc, item) => {
    const filterValues = data[item.key];
    if (excludeCondition && excludeCondition(item, filterValues)) {
      return [...acc, item];
    }
    const isMissingValues = !filterValues || Array.isArray(filterValues) && !filterValues.length || !Array.isArray(filterValues) && (!filterValues.min && !filterValues.max || filterValues.min === filterValues.max);
    if (isMissingValues) {
      return [...acc, item];
    }
    const isHideSingleOption = "hideSingleOption" in item && item.hideSingleOption;
    const isDependency = isItemDependency(item, filterItems);
    const isInIncludeList = [
      ConstructorWidgetEnum.FilterLocation,
      ConstructorWidgetEnum.FilterCheckboxGroup,
      ConstructorWidgetEnum.FilterModels,
      ConstructorWidgetEnum.FilterColorPicker,
      ConstructorWidgetEnum.FilterMultipleSelect,
      ConstructorWidgetEnum.FilterSelect
    ].includes(item.type);
    if (!Array.isArray(filterValues)) {
      return acc;
    }
    const isSingleValue = [...filterValues].length <= 1;
    if (isHideSingleOption && !isDependency && isInIncludeList && isSingleValue) {
      return [...acc, item];
    }
    return acc;
  }, []);
  return filtersToRemove;
}
function removeEmptyFilterGroups(items) {
  return items.filter((item) => {
    if ("items" in item && Array.isArray(item.items) && item.items.length === 0) {
      return false;
    }
    return true;
  });
}
function removeItemsFromGrid(grid, removeItems) {
  const gridItems = [];
  grid.items.forEach((item) => {
    if (instanceOfGrid(item)) {
      const subgrid = removeItemsFromGrid(item, removeItems);
      gridItems.push(subgrid);
      return;
    }
    const gridItem = item;
    if (!("key" in gridItem)) {
      gridItems.push(gridItem);
    }
    const isRemoveItem = removeItems.some((removeItem) => {
      if ("key" in removeItem && "key" in gridItem) {
        return removeItem.key === gridItem.key;
      }
      return false;
    });
    if (!isRemoveItem) {
      gridItems.push(gridItem);
    }
  });
  const gridItemsWithoutEmpty = removeEmptyFilterGroups(gridItems);
  return {
    ...grid,
    items: gridItemsWithoutEmpty
  };
}
function isItemDependency(item, items) {
  const isDependency = items.some((i) => {
    if ("dependencies" in i && Array.isArray(i.dependencies)) {
      return i.dependencies.includes(item.key);
    }
    return false;
  });
  return isDependency;
}
const excludeInvalidFilterGrid = (grid, data, excludeCondition) => {
  const filterItems = getFiltersFromGrid(grid);
  const filterItemsToRemove = getExcludingItems(filterItems, data, excludeCondition);
  const filteredGrid = removeItemsFromGrid(grid, filterItemsToRemove);
  return filteredGrid;
};
export {
  excludeInvalidFilterGrid
};
